import "../styles/default.less"

const creatableStyle = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? "var(--primary)" : "var(--grey)", 
    boxShadow: state.isFocused ? `0 0 0 1px var(--primary)` : "none", 
    borderRadius: "var(--border-radius-medium)", 
    fontSize: "var(--font-size-medium)", 
    paddingLeft: "var(--dim-small)", 
    fontWeight: "var(--font-weight-normal)",
    transition: "all 0.3s ease",
  }),

  menu: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--secondary)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    zIndex: 100,
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--primary)",
      border: "2px solid var(--white)", 
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "var(--white-opacity)",
    },
  }),

  menuList: (baseStyles) => ({
    ...baseStyles,
    maxHeight: "200px",
    backgroundColor: "var(--white)",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--primary)",
      borderRadius: "8px",
      border: "2px solid var(--white)",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "var(--white-opacity)",
    },
  }),

  option: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isFocused || !state.isSelected ? "var(--black)" : "var(--white)",
    fontSize: "var(--font-size-medium)",
    fontWeight: "var(--font-weight-medium)",
    backgroundColor: state.isFocused
      ? "var(--primary-light)"
      : state.isSelected
      ? "var(--primary)"
      : "var(--white)",
    padding: "var(--dim-small)",
    cursor: "pointer",
    borderRadius: "var(--border-radius-small)",
    "&:active": {
      backgroundColor: "var(--primary)",
      color: "var(--white)",
    },
  }),

  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: "var(--primary)",
    fontSize: "var(--font-size-medium)",
    fontStyle: "italic",
  }),

  input: (baseStyles) => ({
    ...baseStyles,
    color: "var(--black)",
    fontSize: "var(--font-size-medium)",
    fontWeight: "var(--font-weight-normal)",
    paddingTop: "var(--dim-small)",
    paddingBottom: "var(--dim-small)",
  }),

  clearIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "var(--primary)",
    cursor: "pointer",
  }),

  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: "var(--primary)",
    cursor: "pointer",
  }),

  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--primary)",
  }),
};

export default creatableStyle;